import l from "react";
import d from "classnames";
import s from "./loyaltyProgress.module.scss.js";
function g(e, t, a) {
  let r = Math.ceil(Math.sqrt(e));
  return e < 9 && e > 6 || e > 20 ? r += 1 : e === 9 ? r += 2 : e === 10 ? r += 1 : e >= 11 && e <= 12 ? r += 2 : e > 12 && e < 16 ? r += 1 : e < 6 && (r = e), Math.floor((t - a * 2) / r);
}
var _ = /* @__PURE__ */ ((e) => (e[e.STAMP = 0] = "STAMP", e[e.BAR = 1] = "BAR", e[e.NONE = 2] = "NONE", e))(_ || {});
const i = 20;
function y({
  value: e,
  stampImage: t,
  maxValue: a,
  maxWidth: r = 300
}) {
  const n = g(a, r, i);
  return /* @__PURE__ */ l.createElement("div", { className: s.loyaltyProgress__stampsWrapper }, new Array(a).fill(0).map((c, o) => /* @__PURE__ */ l.createElement(
    "div",
    {
      key: `stamp-${o}`,
      className: s.loyaltyProgress__stampItem,
      style: {
        flex: `0 0 ${n}px`
      }
    },
    /* @__PURE__ */ l.createElement(
      "div",
      {
        className: s.loyaltyProgress__stamp,
        style: {
          ...e > o ? {
            backgroundImage: `url(${t})`
          } : {}
        }
      }
    )
  )));
}
function u({
  value: e,
  maxValue: t,
  progressBarColor: a
}) {
  const r = e * 100 / t;
  return /* @__PURE__ */ l.createElement(
    "div",
    {
      className: s.loyaltyProgress__sliderBarWrapper,
      style: {
        "--progress": `${r}%`,
        "--progressBarColor": a
      }
    },
    /* @__PURE__ */ l.createElement("div", { className: s.loyaltyProgress__sliderBarWrapper__bar }),
    /* @__PURE__ */ l.createElement("div", { className: s.loyaltyProgress__sliderBarWrapper__pointer })
  );
}
function N(e) {
  const {
    type: t,
    backgroundImage: a,
    backgroundColor: r,
    maxWidth: n = 300,
    children: c
  } = e, o = l.Children.toArray(c).filter(Boolean);
  return /* @__PURE__ */ l.createElement(
    "div",
    {
      "data-testid": "loyalty-progress",
      className: d({
        [s.loyaltyProgress]: !0,
        [s.loyaltyProgress__progress]: t === 1,
        [s.loyaltyProgress__stamps]: t === 0
        /* STAMP */
      }),
      style: {
        "--backgroundColor": r ?? "inherit",
        "--stampsPadding": `${i}px`,
        "--maxWidth": `${n}px`,
        backgroundImage: `url(${a})`
      }
    },
    t === 0 && /* @__PURE__ */ l.createElement(y, { ...e }),
    t === 1 && /* @__PURE__ */ l.createElement(u, { ...e }),
    o.length > 0 && /* @__PURE__ */ l.createElement("div", { className: s.loyaltyProgress__child }, o)
  );
}
export {
  N as LoyaltyProgress,
  _ as LoyaltyProgressType
};
//# sourceMappingURL=LoyaltyProgress.js.map
